const ASSET_LOAD_PATTERNS = [
  "not a valid javascript mime type",
  "failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "importing a module script failed",
  "chunkloaderror",
  "loading chunk",
];

/** Browser-specific messages for a JS chunk that could not be loaded. */
export function isJavaScriptAssetLoadError(error: Error): boolean {
  const haystack = `${error.name} ${error.message}`.toLowerCase();
  return ASSET_LOAD_PATTERNS.some((pattern) => haystack.includes(pattern));
}
